<div class="body-container-wrapper" page-name="historical-nav">
    <section class="first-sec">
        <div class="card first-card">
            <div class="justify-content-md-center row">
                <div class="col-md-4 first-card-image">
                    <!-- <img src="../../assets/images/historical-nav/mf-banner.png" class="img-fluid rounded-start" alt="..."> -->
                </div>
                <div class="col-md-5">
                    <div class="card-body">
                        <h5 class="card-title text-danger">Mutual Fund</h5>
                        <p class="card-text">Mutual Funds are among the hottest favourites with all types of investors.
                            Investing in mutual funds ranks among one of the preferred ways of creating wealth over the
                            long term.</p>

                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="bgwhite">

        <div class="container">
            <div class="row">
             
                <div class="col-3">
                    <div class="sidebar">
                        <ul>
                            <li class="border-bottom-0">
                                <h6>Investments</h6>
                            </li>
                            <li>
                                <a id="introduction" class="active">
                                    <span class="heading">Introduction</span>
                                    <span class="tag">about the mutual fund in brief</span>
                                    <i class="bi bi-currency-dollar"></i>
                                </a>
                            </li>
                            <li>
                                <a id="nfos">
                                    <span class="heading">NFOs</span>
                                    <span class="tag">More about New Fund Offerings</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="fund-manager">
                                    <span class="heading">Fund Manager's Desk</span>
                                    <span class="tag">Know what experts are saying</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="faqs">
                                    <span class="heading">FAQs</span>
                                    <span class="tag">Get the answers to your questions</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="euin">
                                    <span class="heading">EUIN</span>
                                    <span class="tag">Employee Unique Identification No.</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="amc">
                                    <span class="heading">AMC Links for Investment</span>
                                    <span class="tag">Invest Directly Using AMC Links</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li class="border-bottom-0">
                                <h6>research tools</h6>
                            </li>
                            <li>
                                <a id="latest-news">
                                    <span class="heading">Latest News</span>
                                    <span class="tag">Get updated with current market news</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="top-funds">
                                    <span class="heading">Top-Funds</span>
                                    <span class="tag">Top performing funds</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="latest-nav">
                                    <span class="heading">Latest NAV</span>
                                    <span class="tag">Know your funds current value</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="historical-nav">
                                    <span class="heading">Historical NAV</span>
                                    <span class="tag">Track the fund's past performance</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="nav-graph">
                                    <span class="heading">NAV Graph</span>
                                    <span class="tag">Ups & Downs of fund value</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="compare-funds">
                                    <span class="heading">Compare Funds</span>
                                    <span class="tag">Compare and pick the best</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="dividends-declared">
                                    <span class="heading">Dividends Declared</span>
                                    <span class="tag">Get the dividend details</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="fund-barometer">
                                    <span class="heading">Fund Barometer</span>
                                    <span class="tag">Know various Fund performance</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>
                            <li>
                                <a id="disclosure">
                                    <span class="heading">Disclosure</span>
                                    <span class="tag">--</span>
                                    <i class="bi bi-bar-chart"></i>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="col-9">
                    <div class="sidebar-container">
                        <div class="sidebar-nav introduction active">
                            <div class="row">
                                <div class="col-12">
                                    <h6>Invest in Mutual Funds Online – Start Here</h6>
                                </div>
                                <div class="col-12 mt-3">
                                <div class="card">
                                    <div class="row mb-3 ms-0">
                                        <div class="col-md-3 mt-3">
                                            <img src="../../assets/images/historical-nav/mutual-funds-img.jpg"
                                                class="img-fluid rounded-start" alt="...">
                                        </div>
                                        <div class="col-md-9">
                                            <div class="card-body">
                                                <!-- <h5 class="card-title text-danger">Mutual Fund</h5> -->
                                                <p class="card-text text-dark">Mutual Funds are among the hottest
                                                    favorites with all types of investors. Investing in mutual funds
                                                    ranks among one of the preferred ways of creating wealth over the
                                                    long term. In fact, mutual funds represent the hands-off approach to
                                                    entering the equity market. There are a wide variety of mutual funds
                                                    that are viable investment avenues to meet a wide variety of
                                                    financial goals. This section explains the various aspects of Mutual
                                                    Funds.</p>

                                            </div>
                                        </div>
                                        <div class="col-12 mt-5">
                                            <p class="card-text text-dark">MUTUAL FUND INVESTMENTS ARE SUBJECT TO MARKET
                                                RISKS. READ ALL SCHEME RELATED DOCUMENTS CAREFULLY</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                                <div class="col-12 mt-5">
                                    <div class="accordion" id="accordionExample">
                                        <div class="card">
                                          <div class="card-header" id="headingOne">
                                            <h2 class="mb-0">
                                              <button class="btn btn-block" type="button" data-bs-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                
                                                <span>What is Mutual Fund and Why Mutual Fund?</span>
                                                <i class="bi bi-plus-square-dotted"></i>
                                              </button>
                                            </h2>
                                          </div>
                                      
                                          <div id="collapseOne" class="collapse show btn-block" aria-labelledby="headingOne" data-parent="#accordionExample">
                                            <div class="card-body">
                                                <ul>
                                                    <li>
                                                        <p> A mutual fund is the trust that pools the savings of a number of investors who share a common financial goal.</p>
                                                    </li>
                                                    <li>
                                                        <p>
                                                            Anybody with an investible surplus of as little as a few hundred rupees can invest in Mutual Funds.
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>
                                                            The money thus collected is then invested by the fund manager in different types of securities. These could range from shares to debentures to money market instruments, depending upon the scheme’s stated objective.
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>
                                                            It gives the market returns and not assured returns
                                                        </p>
                                                    </li>
                                                </ul>
                                              
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card">
                                          <div class="card-header" id="headingTwo">
                                            <h2 class="mb-0">
                                              <button class="btn btn-link collapsed btn-block" type="button" data-bs-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                <span>Advantages of Mutual Funds</span>
                                                <i class="bi bi-plus-square-dotted"></i>
                                              </button>
                                            </h2>
                                          </div>
                                          <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                            <div class="card-body">
                                              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card">
                                          <div class="card-header" id="headingThree">
                                            <h2 class="mb-0">
                                              <button class="btn btn-block collapsed" type="button" data-bs-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                <span>How do I make money from a mutual fund?</span>
                                                <i class="bi bi-plus-square-dotted"></i>
                                              </button>
                                            </h2>
                                          </div>
                                          <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                            <div class="card-body">
                                              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                                            </div>
                                          </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingFour">
                                              <h2 class="mb-0">
                                                <button class="btn btn-block collapsed" type="button" data-bs-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                  <span>How to invest in Mutual Funds, Selection Process- 3 steps</span>
                                                  <i class="bi bi-plus-square-dotted"></i>
                                                </button>
                                              </h2>
                                            </div>
                                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                              <div class="card-body">
                                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                                              </div>
                                            </div>
                                          </div>
                                      </div>
                                </div>

                            </div>

                        </div>
                        <div class="sidebar-nav nfos">
                            <h6>nfos</h6>
                        </div>
                        <div class="sidebar-nav fund-manager">
                            <h6>Fund Manager</h6>
                        </div>
                        <div class="sidebar-nav faqs">
                            <h6>faqs</h6>
                        </div>
                        <div class="sidebar-nav euin">
                            <h6>euin</h6>
                        </div>
                        <div class="sidebar-nav amc">
                            <h6>amc</h6>
                        </div>
                        <div class="sidebar-nav latest-news">
                            <h6>latest news</h6>
                        </div>
                        <div class="sidebar-nav top-funds">
                            <h6>top-funds</h6>
                        </div>
                        <div class="sidebar-nav latest-nav">
                            <h6>latest-nav</h6>
                        </div>
                        <div class="sidebar-nav historical-nav">
                            <h6>historical-nav</h6>
                        </div>
                        <div class="sidebar-nav nav-graph">
                            <h6>nav-graph</h6>
                        </div>
                        <div class="sidebar-nav compare-funds">
                            <h6>compare-funds</h6>
                        </div>
                        <div class="sidebar-nav dividends-declared">
                            <h6>dividends-declared</h6>
                        </div>
                        <div class="sidebar-nav fund-barometer">
                            <h6>fund-barometer</h6>
                        </div>
                        <div class="sidebar-nav disclosure">
                            <h6>disclosure</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>